const RectIcon: React.FC<{ ratio: number }> = ({ ratio }) => {
  // 设置最大尺寸限制，确保图形在 24x24 的 SVG 容器内
  const maxSize = 18; // 留出一些边距
  const strokeWidth = 2;

  // 根据比例计算宽高
  let width: number;
  let height: number;

  if (ratio >= 1) {
    // 宽度大于等于高度的情况
    width = maxSize;
    height = maxSize / ratio;
  } else {
    // 高度大于宽度的情况
    height = maxSize;
    width = maxSize * ratio;
  }

  return (
    <svg width="24" height="24">
      <rect
        x={(24 - width) / 2}
        y={(24 - height) / 2}
        width={width}
        height={height}
        rx="3"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        fill="none"
      />
    </svg>
  );
};

export default RectIcon;
